import React, { useRef, useState, useEffect } from 'react';
import { useMutation, gql } from '@apollo/client';
import { withTranslation } from 'react-i18next';
import { Button, Box, Typography, Grid, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Alert, Snackbar, Switch, FormControlLabel } from '@mui/material';
import useGlobalStyles from '../../utils/globalStyles';
import { AddNestPass, UpdateNestPass } from '../../apollo';
import useStyles from './styles';

// Your GraphQL query (assuming you still have this)
const ADD_NEST_PASS = gql`${AddNestPass}`;

// Your GraphQL query (assuming you still have this)
const UPDATE_NEST_PASS = gql`${UpdateNestPass}`;

function NestPassModel(props) {
    const { onClose, nestPass: initialNestPass, storeId, refetch } = props;
    const formRef = useRef();
    const isEdit = !!initialNestPass;
    const mutation = isEdit ? UPDATE_NEST_PASS : ADD_NEST_PASS;
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const { t } = props;
    const classes = useStyles();
    const globalClasses = useGlobalStyles();
    const inputTextStyle = { color: 'black' };

    const [formData, setFormData] = useState({
        code: (initialNestPass && initialNestPass.code) && initialNestPass.code || '',
    regularPurchasePrice: (initialNestPass && initialNestPass.regularPurchasePrice) && parseFloat(initialNestPass.regularPurchasePrice) || 0,
    discountedPurchasePrice: (initialNestPass && initialNestPass.discountedPurchasePrice) && parseFloat(initialNestPass.discountedPurchasePrice) || 0,
    hsn: (initialNestPass && initialNestPass.hsn !== undefined && initialNestPass.hsn !== null) && initialNestPass.hsn.toString() || '',
    SGST: (initialNestPass && initialNestPass.SGST !== undefined) && parseFloat(initialNestPass.SGST) || 0,
    CGST: (initialNestPass && initialNestPass.CGST !== undefined) && parseFloat(initialNestPass.CGST) || 0,
    IGST: (initialNestPass && initialNestPass.IGST !== undefined) && parseFloat(initialNestPass.IGST) || 0,
    gracePeriodForRenewal: (initialNestPass && initialNestPass.gracePeriodForRenewal) && parseInt(initialNestPass.gracePeriodForRenewal) || '',
    notificationForExpiration: (initialNestPass && initialNestPass.notificationForExpiration) && parseInt(initialNestPass.notificationForExpiration) || '',
    isActive: (initialNestPass && initialNestPass.isActive !== undefined) && initialNestPass.isActive || true,
    expiryInMonths: (initialNestPass && initialNestPass.expiryInMonths) && parseInt(initialNestPass.expiryInMonths) || '',
    message: (initialNestPass && initialNestPass.message) && initialNestPass.message || '',
    nestPassExpiryReminderPushNotificationMessage: (initialNestPass && initialNestPass.nestPassExpiryReminderPushNotificationMessage) && initialNestPass.nestPassExpiryReminderPushNotificationMessage || '',
   
    });

    const [formErrors, setFormErrors] = useState({});

    useEffect(() => {
        if (initialNestPass) {
            setFormData({
                code: (initialNestPass && initialNestPass.code) && initialNestPass.code || '',
    regularPurchasePrice: (initialNestPass && initialNestPass.regularPurchasePrice) && parseFloat(initialNestPass.regularPurchasePrice) || 0,
    discountedPurchasePrice: (initialNestPass && initialNestPass.discountedPurchasePrice) && parseFloat(initialNestPass.discountedPurchasePrice) || 0,
    hsn: (initialNestPass && initialNestPass.hsn !== undefined && initialNestPass.hsn !== null) && initialNestPass.hsn.toString() || '',
    SGST: (initialNestPass && initialNestPass.SGST !== undefined) && parseFloat(initialNestPass.SGST) || 0,
    CGST: (initialNestPass && initialNestPass.CGST !== undefined) && parseFloat(initialNestPass.CGST) || 0,
    IGST: (initialNestPass && initialNestPass.IGST !== undefined) && parseFloat(initialNestPass.IGST) || 0,
    gracePeriodForRenewal: (initialNestPass && initialNestPass.gracePeriodForRenewal) && parseInt(initialNestPass.gracePeriodForRenewal) || '',
    notificationForExpiration: (initialNestPass && initialNestPass.notificationForExpiration) && parseInt(initialNestPass.notificationForExpiration) || '',
    isActive: (initialNestPass && initialNestPass.isActive !== undefined) && initialNestPass.isActive || true,
    expiryInMonths: (initialNestPass && initialNestPass.expiryInMonths) && parseInt(initialNestPass.expiryInMonths) || '',
    message: (initialNestPass && initialNestPass.message) && initialNestPass.message || '',
    nestPassExpiryReminderPushNotificationMessage: (initialNestPass && initialNestPass.nestPassExpiryReminderPushNotificationMessage) && initialNestPass.nestPassExpiryReminderPushNotificationMessage || '',
                
            });
        } else {
            setFormData({
                code: '',
                regularPurchasePrice: '',
                discountedPurchasePrice: '',
                hsn: '',
                SGST: 0,
                CGST: 0,
                IGST: 0, // Default to 0 for new entries
                gracePeriodForRenewal: '',
                notificationForExpiration: '',
                isActive: true,
                expiryInMonths: '',
                message: '',
                nestPassExpiryReminderPushNotificationMessage: '',
                
            });
        }
    }, [initialNestPass]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
        if (formErrors[name]) {
            setFormErrors({ ...formErrors, [name]: '' });
        }
    };

    const onCompleted = (data) => {
        setSuccess(isEdit ? t('Nest Pass updated successfully') : t('Nest Pass added successfully'));
        setError('');
        setOpenSnackbar(true);
        refetch(); // Refresh the Nest Pass list
        setTimeout(onClose, 1500); // Close the dialog after a short delay
    };

    const onError = ({ graphQLErrors, networkError }) => {
        setSuccess('');
        if (graphQLErrors) {
            setError('Something went wrong!');
            graphQLErrors.forEach(({ message }) => console.error(message));
        } else if (networkError) {
            setError(t('Network error') + ': ' + networkError.message);
        } else {
            setError('Something went wrong!');
        }
        setOpenSnackbar(true);
    };

    const [mutate, { loading: mutateLoading }] = useMutation(mutation, {
        onError,
        onCompleted,
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        const { _id, ...nestPassInput } = formData;
        const variables = {
            nestPassInput: {
                ...nestPassInput,
                regularPurchasePrice: parseFloat(formData.regularPurchasePrice) || 0,
                discountedPurchasePrice: parseFloat(formData.discountedPurchasePrice) || 0,
               
                SGST: parseFloat(formData.SGST) || 0, // Convert or set to null if empty
                CGST:  parseFloat(formData.CGST) || 0, // Convert or set to null if empty
                IGST: parseFloat(formData.IGST) || 0,
                gracePeriodForRenewal:  parseInt(formData.gracePeriodForRenewal) || 0, // Convert to integer
                notificationForExpiration: parseInt(formData.notificationForExpiration) || 0, // Convert to integer
                expiryInMonths: parseInt(formData.expiryInMonths) || 0, // Convert to integer

            },
        };
        mutate({ variables });
    };

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    return (
        <Dialog open={true} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                <Box className={props.vendor ? classes.heading : classes.heading}>
                    <Typography className={props.vendor ? classes.textWhite : classes.textWhite}>
                        {isEdit ? t('Edit Nest Pass') : t('Add New Nest Pass')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <form ref={formRef} onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="code"
                                label={t('Code')}
                                variant="outlined"
                                fullWidth
                                value={formData.code}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.code)}
                                helperText={formErrors.code}
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="regularPurchasePrice"
                                label={t('Regular Price')}
                                variant="outlined"
                                fullWidth
                                value={formData.regularPurchasePrice}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.regularPurchasePrice)}
                                helperText={formErrors.regularPurchasePrice}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="discountedPurchasePrice"
                                label={t('Discounted Price')}
                                variant="outlined"
                                fullWidth
                                value={formData.discountedPurchasePrice}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.discountedPurchasePrice)}
                                helperText={formErrors.discountedPurchasePrice}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="hsn"
                                label={t('HSN Code')}
                                variant="outlined"
                                fullWidth
                                value={formData.hsn}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.hsn)}
                                helperText={formErrors.hsn}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                name="SGST"
                                label={t('SGST (%)')}
                                variant="outlined"
                                fullWidth
                                value={formData.SGST}
                                onChange={handleInputChange}
                                inputProps={{
                                    style: inputTextStyle,
                                    min: 0,
                                    max: 100,
                                    step: '0.01'
                                }}
                                error={Boolean(formErrors.SGST)}
                                helperText={formErrors.SGST}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                name="CGST"
                                label={t('CGST (%)')}
                                variant="outlined"
                                fullWidth
                                value={formData.CGST}
                                onChange={handleInputChange}
                                inputProps={{
                                    style: inputTextStyle,
                                    min: 0,
                                    max: 100,
                                    step: '0.01'
                                }}
                                error={Boolean(formErrors.CGST)}
                                helperText={formErrors.CGST}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                name="IGST"
                                label={t('IGST (%)')}
                                variant="outlined"
                                fullWidth
                                value={formData.IGST}
                                onChange={handleInputChange}
                                inputProps={{
                                    style: inputTextStyle,
                                    min: 0,
                                    max: 100,
                                    step: '0.01'
                                }}
                                error={Boolean(formErrors.IGST)}
                                helperText={formErrors.IGST}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="gracePeriodForRenewal"
                                label={t('Grace Period (Days)')}
                                variant="outlined"
                                fullWidth
                                value={formData.gracePeriodForRenewal}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.gracePeriodForRenewal)}
                                helperText={formErrors.gracePeriodForRenewal}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="notificationForExpiration"
                                label={t('Notification Before Expiry (Days)')}
                                variant="outlined"
                                fullWidth
                                value={formData.notificationForExpiration}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.notificationForExpiration)}
                                helperText={formErrors.notificationForExpiration}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formData.isActive}
                                        onChange={handleInputChange}
                                        name="isActive"
                                        color="primary"
                                    />
                                }
                                label={t('Is Active')}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="expiryInMonths"
                                label={t('Expiry In Months')}
                                variant="outlined"
                                fullWidth
                                value={formData.expiryInMonths}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.expiryInMonths)}
                                helperText={formErrors.expiryInMonths}
                                type="number"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                name="message"
                                label={t('Customer Message')}
                                variant="outlined"
                                fullWidth
                                value={formData.message}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.message)}
                                helperText={formErrors.message}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                name="nestPassExpiryReminderPushNotificationMessage"
                                label={t('Expiry Reminder Push Notification Message')}
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={2}
                                value={formData.nestPassExpiryReminderPushNotificationMessage}
                                onChange={handleInputChange}
                                inputProps={{ style: inputTextStyle }}
                                error={Boolean(formErrors.nestPassExpiryReminderPushNotificationMessage)}
                                helperText={formErrors.nestPassExpiryReminderPushNotificationMessage}
                            />
                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button
                            className={globalClasses.dashbordBtn}
                            disabled={mutateLoading}
                            type="submit"
                        >
                            {isEdit ? t('Update') : t('Add')}
                        </Button>
                        <Button
                            className={globalClasses.modalCancleBtn}
                            onClick={onClose}
                        >
                            {t('Cancel')}
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={success ? 'success' : 'error'} variant="filled" sx={{ width: '100%' }}>
                    {success || error}
                </Alert>
            </Snackbar>
        </Dialog>
    );
}

export default withTranslation()(NestPassModel);
